import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_IDENTIFIERS'),
  ...asyncTypes('CREATE_IDENTIFIERS')
};

export default TYPES;
